import React from 'react';
import Link from 'next/link';
import { useTranslations } from '../../../locales/useTranslations';
import { BiCheckCircle } from 'react-icons/bi';

const MailServerHeader = () => {
  const { t } = useTranslations();

  return (
    <section className="ms-header">
      <div className="ms-header__decoration ms-header__decoration--1" />
      <div className="ms-header__decoration ms-header__decoration--2" />
      <div className="container ms-header__inner">
        <span className="ms-header__badge">{t('managedServices_mailServer_header_badge')}</span>
        <h1 className="ms-header__title">{t('managedServices_mailServer_header_title')}</h1>
        <p className="ms-header__subtitle">{t('managedServices_mailServer_header_subtitle')}</p>
        <p className="ms-header__description">{t('managedServices_mailServer_header_description')}</p>
        <div className="ms-header__features">
          <div className="ms-header__feature">
            <BiCheckCircle />
            <span>{t('managedServices_mailServer_header_feature1')}</span>
          </div>
          <div className="ms-header__feature">
            <BiCheckCircle />
            <span>{t('managedServices_mailServer_header_feature2')}</span>
          </div>
          <div className="ms-header__feature">
            <BiCheckCircle />
            <span>{t('managedServices_mailServer_header_feature3')}</span>
          </div>
        </div>
        <div className="ms-header__actions">
          <Link href="/kontakt/" className="ms-header__btn-primary">
            {t('managedServices_mailServer_header_cta')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MailServerHeader;
